export const MONTHS = {
  0: 'Январь',
  1: 'Февраль',
  2: 'Март',
  3: 'Апрель',
  4: 'Май',
  5: 'Июнь',
  6: 'Июль',
  7: 'Август',
  8: 'Сентябрь',
  9: 'Октябрь',
  10: 'Ноябрь',
  11: 'Декабрь',
};

export const ROLES = {
  admin: 'admin',
  region: 'operators',
  support: 'support',
  municipality: 'department',
};

export const ROLES_NAMES = {
  [ROLES.admin]: 'Админ',
  [ROLES.region]: 'Оператор',
  [ROLES.support]: 'Поддержка',
  [ROLES.municipality]: 'Муниципалитет',
};

export const SHORT_DAYS = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];
export const DAYS = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];

export const SEND_TYPES = {
  SUPPORT: 1,
  REGION: 2,
  MUNICIPALITY: 3,
};

export const SEND_TYPE_NAMES = {
  [SEND_TYPES.SUPPORT]: 'Техническая поддержка',
  [SEND_TYPES.REGION]: 'Регион',
  [SEND_TYPES.MUNICIPALITY]: 'Муниципалитет',

};
